import { render, staticRenderFns } from "./flowProfit.vue?vue&type=template&id=68ee176d&"
import script from "./flowProfit.vue?vue&type=script&lang=js&"
export * from "./flowProfit.vue?vue&type=script&lang=js&"
import style0 from "./flowProfit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports